import React, { useState } from 'react';
import { Button, Card } from '../../shared/components';
import ExamRunner from './ExamRunner';
import './Exams.css';

export default function Exams() {
  const [started, setStarted] = useState(false);

  if (started) {
    return <ExamRunner onExit={() => setStarted(false)} />;
  }

  return (
    <div className="exams-page">
      <h1>Full Practice Exam</h1>
      <Card className="exams-intro-card">
        <p>
          This simulates the real Series 65 exam format: a timed, full-length set of questions
          drawn proportionally from every topic area, with a pass/fail score and section breakdown.
        </p>
        <ul>
          <li>90 minutes</li>
          <li>60 questions, weighted by topic</li>
          <li>72% required to pass</li>
        </ul>
        <p className="exams-disclaimer">
          Every question here is AI-generated original content written in the style and format of the Series 65 &mdash;
          not actual NASAA exam questions. NASAA copyrights its exam questions and prohibits reproducing them, so this
          exam is a close simulation of what to expect, not a real or leaked exam.
        </p>
        <Button onClick={() => setStarted(true)}>Start timed exam</Button>
      </Card>
    </div>
  );
}
